"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSubTitle = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Icon_1 = require("../../../Icon");
require("./index.scss");
const className = 'page-sub-title';
const PageSubTitle = (props) => {
    const { icon, text, description, modificators } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("h2", { className: `${className}__title` },
            icon && (react_1.default.createElement("span", { className: `${className}__icon` },
                react_1.default.createElement(Icon_1.Icon, { name: icon }))),
            react_1.default.createElement("span", { className: `${className}__text` }, text)),
        description && (react_1.default.createElement("p", { className: `${className}__description` }, description))));
};
exports.PageSubTitle = PageSubTitle;
//# sourceMappingURL=index.js.map